import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/estados-de-folio-placas-tarjetas/';

/**
 * GET AlmacenesVehiculares
 * @returns {Promise<Array<object>>}
 */
export const getEstadosFoliosPlacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET EstadoFolioPlaca
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getEstadoFolioPlaca = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST EstadoFolioPlaca
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEstadoFolioPlaca = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH EstadoFolioPlaca
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEstadoFolioPlaca = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE EstadoFolioPlaca
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteEstadoFolioPlaca = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
